<template>
  <div v-if="listSessions" id="data-list-list-view" class="data-list-container">
    <h3 v-if="type">{{ nameMap[type] }}</h3>
    <!-- type.split(/(?=[A-Z])/).join(" ") -->
    <Loading v-if="!hasLoadedData" />
    <vs-table v-else max-items="100" pagination search :data="mappedListSessions" @selected="item => onClicked(item.id)">
      <template slot="thead">
        <vs-th sort-key="sortVersion">Type</vs-th>
        <vs-th sort-key="venueName">Venue</vs-th>
        <vs-th sort-key="sortSubmittedOn">Submitted on</vs-th>
        <vs-th sort-key="sortSubmittedName">Submitted by</vs-th>
        <vs-th v-if="isScorableListType" sort-key="sortAvgScore">Score</vs-th>
        <vs-th v-else sort-key="hasCriticalNoAnswer">Passed</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="idx" :data="item" v-for="(item, idx) in data">
          <vs-td>
            <div class="product-name font-medium truncate flex flex-row items-center">
              <img width="40" :src="ListIcon" />
              <p class="ml-4">{{ nameMap[item.list.type] }} (v. {{ item.list.version }})</p>
            </div>
          </vs-td>
          <vs-td>
            <code>
              {{ item.venueName }}
            </code>
          </vs-td>
          <vs-td>
            <div class="flex">
              <feather-icon class="mr-1" :icon="'CalendarIcon'" svgClasses="text-grey w-5 h-5" />
              {{ item.submittedAction.timestamp | formatDate }}
            </div>
          </vs-td>
          <vs-td>
            <div class="flex">
              <feather-icon class="mr-1" :icon="'UserIcon'" svgClasses="text-grey w-5 h-5" />
              {{ item.submittedAction.userDisplayName }}
            </div>
          </vs-td>
          <vs-td>
            <div v-if="isScorableListType">
              <vs-chip style="color: black" :color="scoreToColor(item.metric.overallScore.avgScoreScale)"
                >{{ item.metric.overallScore.avgScoreScale }}
              </vs-chip>
            </div>
            <div v-else>
              <vs-chip :color="item.hasCriticalNoAnswer ? 'danger' : 'success'">{{ !item.hasCriticalNoAnswer | yesno }} </vs-chip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ListIcon from "@/assets/images/list-icon.png";

import moment from "moment";

export default {
  components: {},
  data() {
    return {
      moment,
      listId: "",
      type: "",
      ListIcon,
      hasLoadedData: false
    };
  },
  computed: {
    ...mapGetters({
      listSessions: "lists/listSessionsByType",
      activeVenue: "venues/activeVenue",
      nameMap: "lists/nameMap"
    }),

    mappedListSessions() {
      const mapped = this.listSessions.map(e => ({
        ...e,
        sortSubmittedOn: e.submittedAction.timestamp,
        sortVersion: e.list.version,
        sortSubmittedName: e.submittedAction.userDisplayName,
        sortAvgScore: e.metric.overallScore.avgScore,
        hasCriticalNoAnswer: e.metric.hasCriticalResponse
      }));

      // Sort by submitted date
      mapped.sort((a, b) => {
        return b.sortSubmittedOn > a.sortSubmittedOn ? 1 : -1;
      });
      return mapped;
    },

    isScorableListType() {
      return this.mappedListSessions.every(e => e.list.scorable);
    },
    scoreToColor() {
      return score => {
        return this.$store.getters["lists/scoreColor"](score, this.type);
      };
    }
  },
  methods: {
    async onClicked(id) {
      this.$router.push({ name: "list-submission", params: { id: id, type: this.type } }).catch(() => {});
    }
  },
  created() {},
  async mounted() {
    this.listId = this.$route.params.listId;
    // TODO load
    await this.$store.dispatch("lists/getListSessionsByType", {
      venueId: this.activeVenue.venueId,
      listId: this.listId
    });
    if (this.listSessions.length > 0) {
      this.type = this.listSessions[0].list.type;
    }
    this.hasLoadedData = true;
    console.log("Got sessions", this.sessions);
  }
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>